/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav CrashBoxx Icon component.
 */
export const SideNavCrashBoxxIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SideNavCrashBoxxIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <circle cx='6.59319'
          cy='17.4034' r='1.23864'
          transform='rotate(15 6.59319 17.4034)'
          stroke={iconColor}
          strokeWidth='1.5'/>
        <circle cx='15.2814'
          cy='19.7316' r='1.23864'
          transform='rotate(15 15.2814 19.7316)'
          stroke={iconColor}
          strokeWidth='1.5'/>
        <path d='M7.63955 17.6766L11.7459 18.7769L13.946 10.5658C14.089 10.0323 13.7724 9.48401 13.2389 9.34107L5.26207 7.20367C4.7286 7.06073 4.18027 7.37731 4.03732 7.91078L2.09598 15.156C1.95304 15.6894 2.26962 16.2378 2.80309 16.3807L5.7093 17.1594'
          stroke={iconColor}
          strokeWidth='1.5'/>
        <path d='M13.772 11.2175L17.3572 12.1782C17.6679 12.2614 17.9196 12.4891 18.0335 12.7899L19.5673 16.8388C19.6415 17.0349 19.6523 17.2493 19.598 17.4519L18.7413 20.6492L16.5565 20.0638M11.7469 18.7751L13.8734 19.3449'
          stroke={iconColor}
          strokeWidth='1.5'
          strokeLinejoin='round'/>
        <path d='M14.3654 7.44425L12 3.86446L15.0923 4.22828L17.0568 2L18.9577 4.22828L22.05 3.90993L19.9581 7.44425'
          stroke={iconColor}
          strokeWidth='1.5'/>
      </svg>
    )} />
  );
};
